import { parseDate } from "@internationalized/date";
import { DateValue } from "@react-types/datepicker";
import { useField } from "formik";

import { DateInput } from "./DateInput";
import { DateInputFieldProps } from "./types";
import { InputWrapper } from "../../../components/inputs/_assets/input-wrapper/InputWrapper";

/**
 * @deprecated use DateFieldFormikField instead.
 */
export function DateInputField({
  name,
  value = undefined,
  span = "auto",
  testID = "date-input-field",
  ...props
}: DateInputFieldProps) {
  const [field, meta, helpers] = useField(name);

  const handleChange = (calendarDate: DateValue) => {
    helpers.setValue(calendarDate ? calendarDate.toString() : null);
  };

  return (
    <InputWrapper span={span}>
      <DateInput
        isInvalid={Boolean(meta.error)}
        errorMessage={meta.touched ? meta.error : undefined}
        name={field.name}
        {...props}
        defaultValue={undefined}
        value={field.value ? parseDate(field.value) : null}
        onChange={handleChange}
        onBlur={() => {
          helpers.setTouched(true);
        }}
        testID={testID}
      />
    </InputWrapper>
  );
}
